import { Resources } from 'constants/resources';

import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { ReactComponent as CompletedReport } from 'images/completedReport.svg';
import {
  LinkStyled,
  ListItemTextStyled,
} from 'pages/Finance/CumulativeReport/components/CumulativeReportDatagrid/CumulativeReportDatagrid.styled';
import { CumulativeReportFilterValues } from 'pages/Finance/CumulativeReport/CumulativeReportFilter';
import { ListItemIcon } from 'shared/mui/List';
import { MenuItem } from 'shared/mui/MenuItem/MenuItem';
import { CumulativeReport } from 'types/embedded/cumulativeReport';

type Props = {
  record: CumulativeReport;
  filters: CumulativeReportFilterValues;
};

export const CumulativeReportDatagridTransactionsButton: React.FC<Props> = ({
  record,
  filters,
}) => {
  const { createPathWithQuery } = useCreatePathWithQuery();
  const to = createPathWithQuery(
    {
      resource: Resources.OrdersReport,
      type: 'list',
    },
    {
      filter: {
        merchantAccount: filters.merchantAccounts,
        merchant: filters.merchant,
        provider: filters.provider,
        company: filters.company,
        timezone: filters.timezone,
        transactions: {
          createdAt: {
            gte: record.periodFrom,
            lte: record.periodTo,
          },
        },
      },
    },
  );

  return (
    <LinkStyled target="_blank" to={to}>
      <MenuItem sx={{ width: '274px' }}>
        <ListItemIcon>
          <CompletedReport />
        </ListItemIcon>
        <ListItemTextStyled primary="Исполненные транзакции за выбранный период" />
      </MenuItem>
    </LinkStyled>
  );
};
